import 'autotrack';
import 'autotrack/lib/plugins/event-tracker';
import 'autotrack/lib/plugins/outbound-link-tracker';
import 'autotrack/lib/plugins/url-change-tracker';
import 'autotrack/lib/plugins/page-visibility-tracker';

window.zywave = window.zywave || {};
const gaKey = window.zywave.gaKey;

if (gaKey) {
    window.ga = window.ga || function () { (window.ga.q = window.ga.q || []).push(arguments); }; window.ga.l = +new Date;
    window.ga('create', gaKey, 'auto');

    window.ga('require', 'eventTracker', { events: ['click', 'play'] });
    window.ga('require', 'outboundLinkTracker');
    window.ga('require', 'urlChangeTracker');
    window.ga('require', 'pageVisibilityTracker', { sendInitialPageview: true });
}
